<template>
  <nav class="navbar navbar-expand-md navbar-dark bg-dark">
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarNav"
      aria-controls="navbarNav"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <h1 class="navbar-brand mb-0">
      <a href="/">Embers <span>Images</span></a>
    </h1>
    <span class="status-group">
      <span
        class="status version"
        data-toggle="tooltip"
        data-placement="bottom"
        data-html="true"
        title="<div class='text-left'><strong>v1.0</strong><br>Embers Images is officially released!</div>"
        >v1.0</span
      >
    </span>
    <div class="collapse navbar-collapse" id="navbarNav">
      <div v-if="isAuthenticated" class="navbar-nav mr-auto">
        <router-link
          class="nav-item nav-link"
          data-toggle="collapse"
          data-target=".navbar-collapse.collapse.show"
          to="/images"
          >Images</router-link
        >
      </div>
      <div v-else class="navbar-nav mr-auto"></div>
      <div class="navbar-nav">
        <router-link
          class="nav-item nav-link"
          data-toggle="collapse"
          data-target=".navbar-collapse.collapse.show"
          to="/faqs"
          >FAQs</router-link
        >
        <router-link
          class="nav-item nav-link"
          data-toggle="collapse"
          data-target=".navbar-collapse.collapse.show"
          to="/sign-in"
          v-if="!isAuthenticated"
          >Sign In</router-link
        >
        <span class="nav-item dropdown" v-if="isAdmin">
          <a
            class="nav-link dropdown-toggle"
            href="/"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Admin
          </a>
          <div class="dropdown-menu">
            <router-link
              class="dropdown-item"
              data-toggle="collapse"
              data-target=".navbar-collapse.collapse.show"
              to="/pages"
              >Pages</router-link
            >
            <router-link
              class="dropdown-item"
              data-toggle="collapse"
              data-target=".navbar-collapse.collapse.show"
              to="/users"
              >Users</router-link
            >
            <router-link
              class="dropdown-item"
              data-toggle="collapse"
              data-target=".navbar-collapse.collapse.show"
              to="/reports"
              >Reports</router-link
            >
          </div>
        </span>
        <span class="nav-item dropdown" v-if="isAuthenticated">
          <a
            class="nav-link dropdown-toggle"
            href="/"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            @click="updateProfile()"
          >
            {{ user.name }}
          </a>
          <div class="dropdown-menu dropdown-menu-right">
            <div class="text-center avatar">
              <img :src="user.image" />
              <div v-if="user.roles.length > 0" class="text-center">
                <span
                  v-for="role in user.roles"
                  :key="role"
                  class="badge badge-secondary"
                  >{{ role.toUpperCase() }}</span
                >
              </div>
            </div>
            <router-link
              class="dropdown-item"
              data-toggle="collapse"
              data-target=".navbar-collapse.collapse.show"
              :to="`/users/${user._id}/settings`"
              >Settings</router-link
            >
            <div class="dropdown-divider"></div>
            <router-link
              class="dropdown-item"
              data-toggle="collapse"
              data-target=".navbar-collapse.collapse.show"
              to="/sign-in"
              @click.native="signOut()"
              >Sign Out</router-link
            >
          </div>
        </span>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import EzBadges from "@/components/shared/_VueEzBadges";

export default {
  name: "navbar",
  components: {
    EzBadges
  },
  watch: {
    user: "setBackground"
  },
  mounted() {
    /* eslint-disable no-undef */
    $('[data-toggle="tooltip"]').tooltip();
  },
  computed: {
    ...mapGetters(["isAuthenticated", "isAdmin", "isGm"]),
    ...mapState({
      user: state => state.session.user
    })
  },
  methods: {
    ...mapActions(["signOut", "updateProfile"]),
    setBackground() {
      // let body = document.getElementsByTagName("body")[0];
      if (this.user && this.user.settings && this.user.settings.darkMode) {
        $("body").addClass("dark-mode");
      } else {
        $("body").removeClass("dark-mode");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/_global";

.navbar {
  padding: 0 0.5rem;
}

.navbar-toggler {
  padding: 0 0.25rem;
  margin: 0.2rem;
}
.navbar-brand > a {
  color: #ff5800;
  &:hover {
    color: #ff5800;
    text-decoration: none;
  }
  span {
    color: rgba(255, 255, 255, 0.2);
  }
}
.dropdown-menu {
  border-top: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  margin: 0;
}
.avatar {
  margin: 0.5em;
  img {
    border-radius: 50%;
    width: 4rem;
    height: 4rem;
  }
}
h6 {
  color: $gray-500;
}

.status-group {
  margin-right: 0.4em;
  margin-top: -0.3em;
}

.status {
  font-weight: bold;
  color: #ff5800;
  border: 1px solid $gray-700;
  font-size: 0.675em;
  font-weight: bold;
  padding: 0.25em;
  &:hover {
    border: 1px solid #ff5800;
    cursor: pointer;
  }
}
</style>
